import React, {useContext} from 'react';
import {ArticleOverviewGridTeaser} from '../../../../../../../teaser/src/main/resources/scripts/components/article-overview-teaser-content/ArticleOverviewGridTeaser.jsx';
import {articleOverviewStaticContext, ArticleOverviewStaticProvider} from '../ArticleOverviewStatic.jsx';

export default function Teaser({teaserModel, pageModel, clazzes}) {
    return (
        <div className={clazzes}>
            <div className="alpi__cell-aspect-ratio">
                <div className="alpi__content-wrapper -teaser">
                    <div className="alpi__content">
                        <ArticleOverviewGridTeaser teaserModel={teaserModel} pageModel={pageModel} />
                    </div>
                </div>
            </div>
        </div>
    );
}
